/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Font_FamilyInputs */

const en_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Family`)
};

const es_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familia tipográfica`)
};

const fr_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famille de police`)
};

const de_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftart`)
};

const ja_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントファミリー`)
};

const zh_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体集`)
};

const ar_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الخط`)
};

const id_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluarga Fon`)
};

const it_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famiglia Carattere`)
};

const ru_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шрифт`)
};

const pt_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Família da Fonte`)
};

const ko_font_family = /** @type {(inputs: Font_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글꼴`)
};

/**
* | output |
* | --- |
* | "Font Family" |
*
* @param {Font_FamilyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const font_family = /** @type {((inputs?: Font_FamilyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Font_FamilyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_font_family(inputs)
	if (locale === "es") return es_font_family(inputs)
	if (locale === "fr") return fr_font_family(inputs)
	if (locale === "de") return de_font_family(inputs)
	if (locale === "ja") return ja_font_family(inputs)
	if (locale === "zh") return zh_font_family(inputs)
	if (locale === "ar") return ar_font_family(inputs)
	if (locale === "id") return id_font_family(inputs)
	if (locale === "it") return it_font_family(inputs)
	if (locale === "ru") return ru_font_family(inputs)
	if (locale === "pt") return pt_font_family(inputs)
	return ko_font_family(inputs)
});